module.exports = __webpack_public_path__ + "media/images/lb/236-3818834d1d6a76fde58972e6631ad6a8.svg";